import { render } from "./KontakParahita.vue?vue&type=template&id=5216c0fa"
import script from "./KontakParahita.vue?vue&type=script&lang=js"
export * from "./KontakParahita.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__